import sharedModule from '../../shared.module';

sharedModule.directive('onImageLoad', function($parse) {
    return {
        link: function(scope, iElement, iAttrs) {
            iElement.bind('load', function() {
                var expressionHandler = $parse(iAttrs.onImageLoad);
                expressionHandler(scope);
                scope.$apply();
            });
        }
    };
});



// WEBPACK FOOTER //
// ./modules/shared/directives/onImageLoad/onImageLoad.directive.js